import { useSummaryContext } from '../../contexts/SummaryContext';

export const useSummaryLanguage = () => ({
    language: useSummaryContext().language,
});
